export default "__VITE_ASSET__DvugY9mC__"